import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const ReportInput = z.object({
  message: z.string().min(1).max(4000),
  stack: z.string().max(20000).optional().nullable(),
  boundary: z.string().max(120).optional().nullable(),
  url: z.string().max(2000).optional().nullable(),
  userAgent: z.string().max(1000).optional().nullable(),
  release: z.string().max(120).optional().nullable(),
  side: z.enum(["client", "server"]).optional(),
  context: z.record(z.unknown()).optional().nullable(),
});

export const reportClientError = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) => ReportInput.parse(input))
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { error } = await supabaseAdmin.from("client_errors").insert({
      message: data.message,
      stack: data.stack ?? null,
      boundary: data.boundary ?? null,
      url: data.url ?? null,
      user_agent: data.userAgent ?? null,
      release: data.release ?? null,
      side: data.side ?? "client",
      context: (data.context ?? null) as never,
    });
    if (error) throw new Error(error.message);
    return { ok: true as const };
  });